import * as React from "react";

import "./coating.scss";

import {IsShowPricing}    from "@Common/logic/check-show-pricing";
import {cs}               from "@Common/react/chain-services";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {Select}           from "@Common/ui-components/heavy/common/design2/select/select";
import {chain}            from "@Common/utils/fs";
import {indexToArr}       from "@Common/utils/index/index-to-arr";
import {keepOnly}         from "@Common/utils/objects";

import {MoneySpanOld,MoneySpanHideFree,MoneySpanDiscount} from "@Xpresso/routes/common/form/money-span/money-span";

import {PostalProtectAd} from "@Xpresso/routes/customize/steps/postal-protect-ad/postal-protect-ad";
import {CoatingSelector} from "./coating-selector/coating-selector";
import {consumeContext} from "@Common/react/context";

export const Coating = ({finishingTypes, selected, onSelect, isUyoMPB, templateBack, templateBackId, oia, totalQuantity}) => cs(
    consumeContext("session"),
    ({}, next) => !!finishingTypes?.length && next(),
    ["groupedFinishings", (_, next) => next(groupFinishings(finishingTypes))],
    ["uyoGroupedFinishings", (_, next) => next(groupFinishings(finishingTypes.filter((item, index, arr) => item.id === "3" && arr.filter(i => i.dev_key === item.dev_key).length === 1)))],
    ({uyoGroupedFinishings}, next) => isUyoMPB ? !!uyoGroupedFinishings?.length && next() : next(),
    ["showPricing", (_, next) => IsShowPricing({next})],
    ["hasPostalProtectBenefit", ({session}, next) => next(
        session.data.agent?.activeBenefits?.includes("postalProtect")
    )],
    ["isDiscountedPostalProtect", ({hasPostalProtectBenefit}, next) => next(
        (coating) => hasPostalProtectBenefit && coating?.dev_key.startsWith("laminate")
    )],
    ["images", (_, next) => next(
        oia ? (
            !oia.proofs?.length ? (
                ["1","2"].map((side) => ({
                    id: side,
                    url: "assets/NoImageAvailable.png",
                }))
            ) : (
                oia.proofs.map((url, i) => ({
                    id: "" + (i + 1),
                    url,
                }))
            )
        ) : templateBack && (
            getImages({templateBack, templateBackId})
        )
    )],
    ({
        hasPostalProtectBenefit,
        isDiscountedPostalProtect,
        session, 
        showPricing,
        images,
        groupedFinishings,
        uyoGroupedFinishings,
    }) => (
        <div className="coating-49d">
            <div className="side-by-side">
                <div className="coating-section">
                    <div className="title">
                        Coating
                        {InformationBadge({
                            getTooltip: () => "These options are not recommended to be written on, and self-serve adhesive labels may not adhere permanently",
                        })}
                    </div>

                    {showPricing && (
                        MoneySpanHideFree({value: (
                            totalQuantity
                            * (selected && selected.unitPrice || 0)
                            * (isDiscountedPostalProtect(selected) ? 0.5 : 1)
                        )})
                    )}
                    {Select({
                        list: isUyoMPB ? (
                            finishingTypes[0]?.required ? (
                                uyoGroupedFinishings
                            ) : (
                                [null, ...uyoGroupedFinishings??[]]
                            )
                        ) : finishingTypes[0]?.required ? (
                            groupedFinishings
                        ) : (
                            [null, ...groupedFinishings??[]]
                        ),
                        itemToLabel: (o) => o == null ? "None" : o.subGroup,
                        itemToInfo: (o) => (o == null || !showPricing) ? null : isDiscountedPostalProtect(o) ? (
                            MoneySpanDiscount({value: +(getSide(selected?.id, o.sides).unitPrice ?? 0), discountValue: +(getSide(selected?.id, o.sides).unitPrice * 0.5 ?? 0)})
                          ) : MoneySpanOld({
                            value: +(getSide(selected?.id, o.sides).unitPrice ?? 0),
                        }),
                        isSelected: (o) => selected ? o?.dev_key === selected.dev_key : finishingTypes[0]?.required ? o?.dev_key === finishingTypes[0]?.dev_key : o == null,
                        onChange: (o) => onSelect(
                            o ? {
                                dev_key: o.dev_key,
                                id: getSide(selected?.id, o.sides).id,
                            } : {
                                type: "none",
                            }
                        ),
                        forcedExpandLeft: true,
                        xdQaName: "Coating",
                    })}
                </div>
                {(
                    !hasPostalProtectBenefit
                    && finishingTypes.some(item => item.dev_key.startsWith("laminate"))
                    && session.data.agent?.availableBenefits?.includes("postalProtect")
                ) && (
                    PostalProtectAd()
                )}
            </div>


            {isUyoMPB ? (
                finishingTypes[0]?.required ? (
                    <div>Note: {`${finishingTypes[0]?.subGroup}`} will be applied to every page of the brochure.</div>
                ) : (
                    <div>Note: If coating is selected, it will be applied to every page of the brochure.{<br/>}
                    If not selected, the brochure will not have coating.</div>
                )
            ) : (selected && <>
                {!!selected.finishingDelay && (
                    <div className="delay-message">
                        {"Adds " + selected.finishingDelay + " days to production time"}
                    </div>
                )}

                {selected.coatingDescription && (
                    <div className="description">
                        {selected.coatingDescription}
                    </div>
                )}

                {!isUyoMPB && images && (() => {
                    const group = groupedFinishings.find((g) => g.dev_key === selected.dev_key);
                    return (
                        <div className="select-sides">
                            <div className="header">
                                Select Sides
                            </div>

                            {CoatingSelector({
                                images: ["1", "2"].map((id) => {
                                    const isSelected = selected && ["" + id, "3"].includes(selected.id);
                                    const nextIdIfClick = chain(
                                        isSelected ? (
                                            [otherSide(id)] // Unselect this, the only option is selecting the other side
                                        ) : (
                                            ["3", id] // Select this, let's try select both first, if not possible, then select only this
                                        ),
                                        (_) => _.find((id) => group.sides.find((s) => s.id === id)),
                                    );

                                    return ({
                                        src: images.find((img) => img.id == id)?.url,
                                        selected: isSelected,
                                        onSelect: () => onSelect({
                                            id: nextIdIfClick,
                                            dev_key: selected.dev_key,
                                        }),
                                        disabled: !nextIdIfClick,
                                    });
                                })
                            })}
                        </div>
                    );
                })()}
            </>)}
        </div>
    ),
);

const getSide = (id, sides) => sides.find((s) => s.id === id) ?? sides[0];

const otherSide = (id) => id === "1" ? "2" : "1";

const getImages = ({templateBack, templateBackId}) => [
    {
        id: "1",
        url: templateBack.images[0].url,
    },
    {
        id: "2",
        url: templateBack.backs.find((back) => back.id === templateBackId)?.image,
    }
];

const groupFinishings = (finishingTypes) => indexToArr(
    finishingTypes,
    (finishing) => finishing.dev_key,
    (finishingTypes) => ({
        subGroup: finishingTypes[0].subGroup,
        dev_key: finishingTypes[0].dev_key,
        sides: finishingTypes.map((finishing) => keepOnly(finishing, ["id", "unitPrice"])),
    })
);
